import { Navbar } from '../components/layout/Navbar';
import { Footer } from '../components/layout/Footer';
import { HeroSection } from '../components/sections/HeroSection';
import { ServicesSection } from '../components/sections/ServicesSection';
import { StatsSection } from '../components/sections/StatsSection';
import { EventsSection } from '../components/sections/EventsSection';
import { ClientsSection } from '../components/sections/ClientsSection';
import { TestimonialsSection } from '../components/sections/TestimonialsSection';
import { CTASection } from '../components/sections/CTASection';

export default function HomePage() {
  return (
    <div className="page-transition" data-testid="home-page">
      <Navbar />
      <main>
        <HeroSection />
        <ClientsSection />
        <ServicesSection />
        <StatsSection />
        <EventsSection />
        <TestimonialsSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
